<template>
  <div class="exam-guide">
    <SiteHeader />
    <SiteMenu />
    <ExamGuideView v-if="$route.meta.hideExamGuideView" />
    <router-view />
    <SiteFooter />
  </div>
</template>

<script>
import examGuideService from '@/api/examGuide'
import SiteHeader from './SiteComponents/SiteHeader.vue'
import ExamGuideView from './ExamGuideView.vue'
import SiteMenu from './SiteComponents/SiteMenu'
import SiteFooter from './SiteComponents/SiteFooter'

export default {
  name: 'ExamGuide',
  components: {
    SiteHeader,
    ExamGuideView,
    SiteMenu,
    SiteFooter,
  },
  data() {
    return {
      axiosInterceptor: null,
    }
  },
  async mounted() {
    try {
      await this.$recaptchaLoaded()
      this.setupRecaptchaInterceptor()
    } catch (error) {
      console.error('Erro ao carregar reCAPTCHA:', error)
    }
  },
  beforeDestroy() {
    if (this.axiosInterceptor !== null) {
      examGuideService.axios().interceptors.request.eject(this.axiosInterceptor)
    }

    if (this.$recaptchaInstance) {
      this.$recaptchaInstance.hideBadge()
    }
  },
  methods: {
    setupRecaptchaInterceptor() {
      this.axiosInterceptor = examGuideService.axios().interceptors.request.use(
        async config => {
          if (config.baseURL === process.env.EXAM_GUIDE_URL) {
            try {
              const token = await this.$recaptcha('exam_guide_request')
              config.headers['X-Recaptcha-Token'] = token
            } catch (error) {
              console.error('Erro ao obter token reCAPTCHA:', error)
            }
          }
          return config
        },
        error => {
          return Promise.reject(error)
        }
      )
    },
  },
}
</script>

<style lang="scss">
.exam-guide {
  font-family: 'Exo 2', sans-serif !important;
  position: relative;
}
</style>
